import { FILE_ACCESS_PRIVATE, FILE_ACCESS_PUBLIC } from '../constants';
/** The enum's values, in display order. A closed set defined by the model, not derived from rows. */
export const FILE_ACCESS_VALUES = [FILE_ACCESS_PUBLIC, FILE_ACCESS_PRIVATE];
/** Display text for one `file_access` value, e.g. "Public". */
export function fileAccessLabel(fileAccess, translateFn) {
    return translateFn(`file_access.${fileAccess}`);
}
/**
 * Visibility filter options.
 *
 * A fixed list rather than one derived from the loaded rows, unlike the shared file-type filter:
 * the two values are a closed set, and an invoice that happens to have only public attachments
 * today should still offer "Private" — otherwise the filter silently changes shape as rows come
 * and go, which reads as a bug.
 */
export function buildFileAccessOptions(translateFn) {
    return FILE_ACCESS_VALUES.map((value) => ({ value, label: fileAccessLabel(value, translateFn) }));
}
